import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

export const fetchCart = createAsyncThunk(
  "cart/fetchCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/cart")
      return response.data.cart || []
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async ({ product_id, qty = 1 }, { dispatch, rejectWithValue }) => {
    try {
      const numericQty = Number(qty) || 1
      const response = await axios.post("/api/cart/add", {
        product_id,
        qty: numericQty,
      })
      await dispatch(fetchCart())
      return response.data.cartItem
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const updateCartQty = createAsyncThunk(
  "cart/updateCartQty",
  async ({ cartItemId, qty }, { dispatch, rejectWithValue }) => {
    try {
      await axios.put(`/api/cart/update/${cartItemId}`, { qty })
      await dispatch(fetchCart())
      return { cartItemId, qty }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const updateCartItemQty = createAsyncThunk(
  "cart/updateCartItemQty",
  async ({ cart_item_id, qty }, { dispatch, rejectWithValue }) => {
    try {
      await axios.put(`/api/cart/update/${cart_item_id}`, { qty })
      await dispatch(fetchCart())
      return { cart_item_id, qty }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const removeCartItem = createAsyncThunk(
  "cart/removeCartItem",
  async (cartItemId, { dispatch, rejectWithValue }) => {
    try {
      await axios.delete(`/api/cart/${cartItemId}`)
      await dispatch(fetchCart())
      return cartItemId
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

const initialState = {
  items: [],
  loading: false,
  error: null,
  isSidebarOpen: false,
}

export const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    toggleCartSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen
    },
    openCartSidebar: (state) => {
      state.isSidebarOpen = true
    },
    closeCartSidebar: (state) => {
      state.isSidebarOpen = false
    },
    clearCartState: (state) => {
      state.items = []
      state.isSidebarOpen = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.loading = false
        state.items = (action.payload || []).map((item) => ({
          ...item,
          qty: parseInt(item.qty, 10) || 1,
        }))
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(addToCart.fulfilled, (state) => {
        state.isSidebarOpen = true
      })
  },
})

export const {
  toggleCartSidebar,
  openCartSidebar,
  closeCartSidebar,
  clearCartState,
} = CartSlice.actions

export default CartSlice.reducer
